<template>
  <v-card class="app-card">
    <v-card-title class="app-card-title mb-0">
      <v-icon>assignment</v-icon>Exclusão de veículo
    </v-card-title>
    <v-card-text class="app-card-content pl-0 pr-0">
      <v-stepper
        v-model="form.currentStep"
        outlined
        alt-labels
        class="app-stepper"
      >
        <v-stepper-header class="app-stepper-header">
          <v-stepper-step
            :complete="form.currentStep > 1"
            step="1"
            class="app-stepper-header__step"
            color="primary"
          >
            Veículo
          </v-stepper-step>
          <v-divider />
          <v-stepper-step
            :complete="form.currentStep > 2"
            step="2"
            class="app-stepper-header__step"
            color="primary"
          >
            Documentos
          </v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <ExclusaoVeiculoForm />
          </v-stepper-content>
          <v-stepper-content step="2">
            <DocumentosForm
              v-if="form.currentStep===2"
              :resource-id="form.pedido.id"
              :type-solicitation="form.pedido.tipoPedido"
            />
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card-text>
  </v-card>
</template>

<script>
import DocumentosForm from "../components/documentos/Form";

// Vuex Store - Sit Pedidos (mapping actions and states)
import { mapState, mapActions, mapMutations } from "vuex";
const actions = mapActions('sitPedidos', ['clearForm', 'setFormDocuments'])
const state = mapState('sitPedidos', ['form'])
import GlobalStore from "@/store/modules/global";
import ExclusaoVeiculoForm from "./components/veiculo/Form"

export default {
  name: 'ExclusaoVeiculo',

  components: {
    ExclusaoVeiculoForm,
    DocumentosForm
  },

  computed: {
    ...state,
  },

  watch: {
    'form.documents': function(newValue, oldValue) {
      if(newValue && newValue.length) {
        const allUploadeds = newValue.every(d=>d.uploaded)
        if(allUploadeds) {
          this.$router.push({name: "pedidos-detail", params: { id: this.form.pedido.id}})
          GlobalStore.setSnackBar({message: "Pedido criado com sucesso", type: 'success', show: true, timeout: 5000})
        }
      }
    }
  },

  destroyed() {
    this.clearForm();
  },

  methods: {
    ...actions
  }

}
</script>
